import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Test from './pages/Test';
import Library from './pages/Library';
import ArticleDetail from './pages/ArticleDetail';
import CircleDetail from './pages/CircleDetail';
import Login from './pages/Login';
import Mine from './pages/Mine';
import Publish from './pages/Publish';
import ChatList from './pages/ChatList';
import Chat from './pages/Chat';
import Set from './pages/Set';
import MyGroup from './pages/MyGroup';
import './index.css';

const App = () => {
  return (
    <BrowserRouter basename="/h5">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/home" element={<Home />} />
        <Route path="/test" element={<Test />} />
        <Route path="/library" element={<Library />} />
        <Route path="/library/article_detail/:id" element={<ArticleDetail />} />
        <Route path="/circle/details/:id" element={<CircleDetail />} />
        <Route path="/login" element={<Login />} />
        <Route path="/profile" element={<Mine />} />
        <Route path="/publish" element={<Publish />} />
        <Route path="/notification" element={<ChatList />} />
        <Route path="/chat" element={<Chat />} />
        <Route path="/set" element={<Set />} />
        <Route path="/my-group" element={<MyGroup />} />
      </Routes>
    </BrowserRouter>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);